module.exports = __webpack_public_path__ + "img/icons8-редактировать.41469dc9.svg";